import React from 'react';
import { Card, Typography } from 'antd';
import { BugOutlined } from '@ant-design/icons';
import { getActualLoanData } from './essPayload';

const { Text, Paragraph } = Typography;

interface ESSDebugViewProps {
    data: any;
    formikProps?: any;
}

/**
 * Debug component to inspect ESS data structure
 * Remove or disable in production
 */
const ESSDebugView: React.FC<ESSDebugViewProps> = ({ data, formikProps }) => {
    const loanData = formikProps?.values || data;
    const actualData = getActualLoanData(data, formikProps);

    return (
        <Card 
            title={
                <span>
                    <BugOutlined /> ESS Data Debug View
                </span>
            }
            className="mb-4"
            style={{ backgroundColor: '#fff7e6', borderColor: '#ffa940' }}
        >
            <Paragraph>
                <Text strong>Data Structure Check:</Text>
            </Paragraph>
            
            <pre style={{ 
                backgroundColor: '#f5f5f5', 
                padding: '10px', 
                borderRadius: '4px',
                fontSize: '12px',
                maxHeight: '400px',
                overflow: 'auto'
            }}>
                {JSON.stringify({
                    hasCheckNumber: !!actualData?.checkNumber,
                    hasEssLoanApplicationNumber: !!actualData?.essLoanApplicationNumber,
                    hasApplicationNumber: !!actualData?.applicationNumber,
                    hasEssRequestPayload: !!actualData?.essRequestPayload,
                    hasFormattedEssRequestPayload: !!actualData?.formattedEssRequestPayload,
                    essRequestPayloadLength: actualData?.essRequestPayload?.length || 0,
                    loanType: actualData?.loanType,
                    checkNumber: actualData?.checkNumber,
                    essLoanApplicationNumber: actualData?.essLoanApplicationNumber,
                    applicationNumber: actualData?.applicationNumber,
                    dataKeys: Object.keys(loanData || {}),
                    actualDataKeys: Object.keys(actualData || {}),
                    hasValueData: !!loanData?.valueData,
                    // Sample of essRequestPayload
                    essRequestPayloadSample: actualData?.essRequestPayload?.substring(0, 200),
                    formattedEssRequestPayloadKeys:
                        actualData?.formattedEssRequestPayload && typeof actualData.formattedEssRequestPayload === 'object'
                            ? Object.keys(actualData.formattedEssRequestPayload)
                            : []
                }, null, 2)}
            </pre>
            
            <Paragraph className="mt-2">
                <Text type="secondary">
                    This debug view helps verify ESS data is being passed correctly.
                    If you see data here but components are empty, check the parsing logic.
                </Text>
            </Paragraph>
        </Card>
    );
};

export default ESSDebugView;
